module.exports = __webpack_public_path__ + "static/media/choose-shedule.e8e38666.png";